module.exports = __webpack_public_path__ + "img/gd-left-top.65f6a1d1.svg";